import "../scss/main.scss";
import "bootstrap";
import "@popperjs/core";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import Header from './header.js';
/* import Slider from './slider.js'; */
import VideoPoster from './videoPosterOverlay.js';
import Animations from "./animations.js";
import { setOptions } from "./options.js";
import Accordion from "./accordion.js";
import Accordion2 from "./accordion-2.js";
import Feature from "./feature.js";
import SplitFeature from "./splitFeature.js";
import ColumnImages from "./columnImages.js";
import TextMedia from "./textMedia.js";
import Sidebar from "./sidebar.js";
import TextMediaOverlay from "./textMediaOverlay.js";
import Hero from "./hero.js";





const PctApp = (() => {



    /**
     * 
     * @param {*} opts 
     */
    const init = (opts = {}) => {

        setOptions(opts)

        // refresh ScrollTrigger
        window.addEventListener('load', (e) => { 
            ScrollTrigger.refresh();
            console.debug('ScrollTrigger refreshed on load');
        });


        setupStickyHeader();
        /* setupSlider(); */
        setupGlobalModal();
        /* initialization order matters for scrollTrigger pined elements */
        Hero.initialize();
        SplitFeature.initializeAnimatedProduct();
        Accordion.initialize();
        Feature.initializeBike();
        VideoPoster.initialize();
        SplitFeature.initializeProductTeaser();
        Feature.initializeMotor()
        ColumnImages.initialize();
        Accordion2.initialize();
        TextMedia.initialize();
        TextMediaOverlay.initialize();
        Animations.initialize();
        Sidebar.initialize();
        /* VideoModule.initialize(); */

    }

    /**
     * 
     * 
     * requirements:
     * - stick when scrolling down and unstick when scrolling up
     * - shrink height
     * - transparent to solid background
     */
    const setupStickyHeader = () => {

        const headerNode = document.querySelector('header');
        Header.initialize(headerNode);

    };

    /**
     * initialize embla slider
     * 
     */
    const setupSlider = () => {

        const rootEl = document.querySelector('.module-container__slider');
        const sliderOptions = {
            loop: true,
        }
        const slider = Slider.initialize(rootEl, sliderOptions);

        if (!slider) {
            return;
        }

        const dotsEl = rootEl.querySelector('.slider__controls__dots');

        const dotBtnsAndClickHandlers = Slider.addDotBtnsAndClickHandlers(slider, dotsEl);

        slider.on('destroy', dotBtnsAndClickHandlers);

    };

    /**
     * replace innerHTML of the global modal element by the template elements content defined by the trigger elements data-modal-content-id
     */
    const setupGlobalModal = () => {
        
        const modal = document.getElementById("global-modal");
        
        modal.addEventListener("show.bs.modal", event => {
            const trigger = event.relatedTarget;
            const templateId = trigger.dataset.modalContentId;
            const template = document.getElementById(templateId);

            const modal_body = modal.querySelector(".modal-body-content");
            modal_body.innerHTML = "";
            modal_body.appendChild(template.content.cloneNode(true));

        });

    };


    return {
        init
    }

})();

window.PctApp = PctApp; 
